import { useRef, useState, useCallback } from "react";

export const BeforeAfter = ({ image, label }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.clientX ?? e.touches?.[0]?.clientX);
  };
  const stop = () => (dragging.current = false);

  return (
    <div
      ref={ref}
      className="relative aspect-[4/3] overflow-hidden border border-white/10 cursor-ew-resize select-none group"
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={stop}
      onMouseLeave={stop}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={stop}
      data-testid={`before-after-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {/* AFTER (full color) */}
      <img src={image} alt={`${label} after`} className="absolute inset-0 h-full w-full object-cover" draggable="false" />
      <span className="absolute bottom-4 right-4 z-20 text-[10px] uppercase tracking-[0.25em] text-gold bg-black/60 px-2 py-1">
        After
      </span>

      {/* BEFORE (dull) clipped */}
      <div className="absolute inset-0 z-10" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={image}
          alt={`${label} before`}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ filter: "grayscale(0.75) brightness(0.55) contrast(0.9)" }}
          draggable="false"
        />
        <div className="absolute inset-0 bg-black/20" />
        <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.25em] text-white/70 bg-black/60 px-2 py-1">
          Before
        </span>
      </div>

      {/* Handle */}
      <div className="absolute top-0 bottom-0 z-20 w-px bg-gold pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-9 w-9 rounded-full border border-gold bg-black/70 flex items-center justify-center text-gold text-xs">
          &#8596;
        </div>
      </div>

      <span className="absolute top-4 left-4 z-20 font-serif italic text-lg text-white/90">{label}</span>
    </div>
  );
};
